import { render, staticRenderFns } from "./AR-PH-Notice.vue?vue&type=template&id=82a2c9ac&scoped=true&"
import script from "./AR-PH-Notice.vue?vue&type=script&lang=js&"
export * from "./AR-PH-Notice.vue?vue&type=script&lang=js&"
import style0 from "./AR-PH-Notice.vue?vue&type=style&index=0&id=82a2c9ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a2c9ac",
  null
  
)

export default component.exports